import styled from "styled-components";

const Input = styled.input`
  border: 1.5px solid limegreen;
  border-radius: 5px;
  outline: none;
  background: black;
  height: 32px;
  width: 90%;
  color: limegreen;
  padding: 0.2em 1em;
`;
export default Input;
